import { useState, useEffect, useRef, useLayoutEffect } from "react";
const useViewport = () => {
  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleWindowResize = () => {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);

  return { width, height };
};

export function useCursorPopup(
  active: boolean,
  onClose: () => void,
  extraRefs: React.RefObject<HTMLElement>[] = []
) {
  const [pos, setPos] = useState({ x: 0, y: 0, width: 0 });
  const ref = useRef<HTMLDivElement>(null);

  const openAtCursor = (e: React.MouseEvent) => {
    e.stopPropagation();
    setPos({ x: e.clientX, y: e.clientY, width: window.innerWidth });
  };

  useLayoutEffect(() => {
    if (!active || !ref.current) return;

    const r = ref.current.getBoundingClientRect();
    setPos(p => ({
      x: Math.min(p.x, window.innerWidth - r.width),
      y: Math.min(p.y, window.innerHeight - r.height),
      width: window.innerWidth
    }));
    // console.log('window.innerWidth = ' + window.innerWidth);
  }, [active]);

  useEffect(() => {
    if (!active) return;

    const handleClickOutside = (e: MouseEvent) => {
      const target = e.target as Node;
      if ((e.target as HTMLElement).closest(".react-datepicker")) {
        return;
      }

      const isInsideMain =
        ref.current?.contains(target);

      const isInsideExtra =
        extraRefs.some(r => r.current?.contains(target));

      if (!isInsideMain && !isInsideExtra) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, [active, onClose, extraRefs]);

  return { ref, pos, openAtCursor };
}



export { useViewport };
